// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".slide-down-enter-active[data-v-b473ea24],.slide-down-leave-active[data-v-b473ea24]{transition:all .3s ease-in-out}.slide-down-enter[data-v-b473ea24],.slide-down-leave-to[data-v-b473ea24]{opacity:0;transform:translateY(-60px)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
